// extracted by css-extract-rspack-plugin
export default {"link":"_b73fcffe"};